import getConfig from 'next/config';
import { useEffect } from 'react';
import { apiGatewayClient, clinicClient, paziresh24AppClient } from '@/common/apis/client';
import { startUxIssueRum } from '@/common/services/rum/uxIssue';
import { splunkInstance } from '@/common/services/splunk';
import { growthbook } from 'src/pages/_app';

/**
 * Booking-flow problems seen from the browser: a slow or failed call, or a patient who
 * leaves while a call is pending. Same index and shape as the FactorIssue events.
 * Renders nothing. See src/common/services/rum/uxIssue.ts and docs/performance.md.
 */
export default function BookingUxIssueRum() {
  useEffect(() => {
    const { publicRuntimeConfig } = getConfig() ?? {};
    // Same gate as the other RUM: nothing from dev builds.
    if (!publicRuntimeConfig?.IS_PRODUCTION) return;
    return startUxIssueRum({
      clients: [clinicClient, apiGatewayClient, paziresh24AppClient],
      getFeature: (key, fallback) => growthbook.getFeatureValue(key, fallback as any) as typeof fallback,
      send: ({ event_type, ...event }) => {
        void splunkInstance('booking').sendEvent({ group: 'UxIssue', type: event_type, event, keepalive: true });
      },
    });
  }, []);

  return null;
}
